<template>
  <div class="d-flex align-items-center scrollarea">
    <div >
      <div class="flex-shrink-0 p-3 bg-sidebar" style="width: 280px" >
        <a href="/" class="align-items-center pb-3 link-dark text-decoration-none border-bottom">
          <!-- <svg class="bi pe-none me-2" width="30" height="24"><use xlink:href="#bootstrap"></use></svg> -->
        </a>
        <ul class="list-unstyled ps-0 sidebar-fixed-area sidebarScroll">
          <div class="mb-3 text-center me-5 mt-3">
            <img style="width: 150px" src="@/assets/images/logo_qnbpay.png" alt="test" />
          </div>
          <li class="mb-3">
            <router-link :to="{ name: 'HomePage' }" class="btn btn-title d-inline-flex align-items-center rounded border-0 collapsed">
              Başlangıç
            </router-link>
          </li>

          <li class="mb-3">
            <router-link :to="{ name: 'AccessUrls' }" class="btn btn-title d-inline-flex align-items-center rounded border-0 collapsed">
              Erişim URL’leri
            </router-link>
          </li>

          <li class="mb-3">
            <router-link :to="{ name: 'MerchantInformations' }" class="btn btn-title d-inline-flex align-items-center rounded border-0 collapsed">
              Test Üye İşyeri Bilgileri
            </router-link>
          </li>

          <li class="mb-3">
            <router-link :to="{ name: 'TestCards' }" class="btn btn-title d-inline-flex align-items-center rounded border-0 collapsed">
              Test Kredi Kartı Bilgileri
            </router-link>
          </li>

          <li class="mb-3">
            <button
              class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#token-collapse"
              aria-expanded="false"
            >
              Token ve Taksit Alma
            </button>
            <div class="collapse" id="token-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link :to="{ name: 'Tokenize' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Token Alma</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'InstallmentInformations' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Taksit Bilgisi Alma</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'MerchantCommissionAPI' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Üye İşyeri Komisyon API</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'MerchantActiveInstallments' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Üye İşyeri Aktif Taksitleri</div>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <button
              class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#transactions-collapse"
              aria-expanded="false"
            >
              Ödeme, Kontrol ve İade
            </button>
            <div class="collapse" id="transactions-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link :to="{ name: 'HashVerify' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Hash Doğrulama Örneği</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'TDPayment' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>3D Ödeme</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'CompletePaymentAPI' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>CompletePayment Api</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'NonSecurePayment' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Non-Secure Ödeme</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'NonSecureTDPayment' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>QNBpay ile Ödeme</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'TransactionStatus' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>İşlem Durumu</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'PaymentVerify' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Ödeme Doğrulama</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'PaymentRefund' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>İşlem İade</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'GetTransaction' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>İşlem Al</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'AllTransactions' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Bütün İşlemler</div>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <button
              class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#codes-collapse"
              aria-expanded="false"
            >
              Durum Kodları
            </button>
            <div class="collapse" id="codes-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link :to="{ name: 'ServerStatusCodes' }" class="link-dark d-inline-flex text-decoration-none rounded"
                    >Sunucu Durum Kodları
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'ApplicationStatusCodes' }" class="link-dark d-inline-flex text-decoration-none rounded"
                    >Uygulama Durum Kodları
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <button
              class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#webhook-collapse"
              aria-expanded="false"
            >
              WebHook
            </button>
            <div class="collapse" id="webhook-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link :to="{ name: 'PaymentWebHook' }" class="link-dark d-inline-flex text-decoration-none rounded"
                    >Satış WebHook</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'RefundWebHook' }" class="link-dark d-inline-flex text-decoration-none rounded">İade WebHook</router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <router-link :to="{ name: 'PostmanCollections' }" class="btn btn-title d-inline-flex align-items-center rounded border-0 collapsed"
              >Postman Koleksiyonu</router-link
            >
          </li>
          
          <li class="mb-3">
            <router-link :to="{ name: 'SampleProject' }" class="btn btn-title d-inline-flex align-items-center rounded border-0 collapsed"
              >Örnek Proje</router-link
            >
          </li>

          <li class="mb-3">
            <button
              class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#moneyTransfer-collapse"
              aria-expanded="false"
            >
              Eklentiler
            </button>
            <div class="collapse" id="moneyTransfer-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link :to="{ name: 'WooCommerce' }" class="link-dark d-inline-flex text-decoration-none rounded">WooCommerce</router-link>
                </li>
              </ul>
            </div>
            <div class="collapse" id="moneyTransfer-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li><router-link :to="{ name: 'OpenCart' }" class="link-dark d-inline-flex text-decoration-none rounded">OpenCart</router-link></li>
              </ul>
            </div>
          </li>

          <!-- <li class="border-top my-3"></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-sidebar {
  background-color: #f8f9fa !important;
  min-height: calc(100vh - 0px);
  height: auto;
}

.sidebar-fixed-area {
  position: fixed;
  overflow-y: auto;
  top: 0;
  bottom: 0;
  width: 280px !important;
}
</style>
